import { render, staticRenderFns } from "./crearCategoria.vue?vue&type=template&id=2ebea162"
import script from "./crearCategoria.vue?vue&type=script&lang=js"
export * from "./crearCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports